import { Outlet } from 'react-router-dom';

import { useSseConnection } from '../../hooks/use-sse-connection';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

export function Layout(): JSX.Element {
  // Story 8.5/8.4 — conexão SSE global pra invalidar caches em tempo real.
  const { connected } = useSseConnection('/identities');

  return (
    <div className="grid min-h-screen grid-cols-[240px_1fr] bg-page text-ink">
      <Sidebar />
      <div className="flex min-w-0 flex-col">
        <Topbar sseConnected={connected} />
        <main className="flex-1 overflow-y-auto px-[22px] py-[22px]">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
